import { PhotoStep } from 'model/domain';
import { h } from 'preact';
import { useStore } from 'effector-react';
import { step$ } from 'model/flows/verification.model';

import { DocumentFront } from './document-front';
import { DocumentBack } from './document-back';

export const Document = () => {
	const step = useStore(step$);

	return step === PhotoStep.front_side ? (
		<DocumentFront/>
	) : (
		<DocumentBack/>
	);
};
